module.exports = __webpack_public_path__ + "img/video.d726af2a.png";